import { apiWithBody, apiWithQuery, ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { ApiDef_MultiVar, DBDef_MultiVar } from '@app/dp-shared';
import { ModuleFE_NLPData, ModuleFE_Reference, ModuleFE_Variable } from '@app/hcs-frontend';
import { Filter, filterDuplicates, filterInstances, MUSTNeverHappenException } from '@nu-art/ts-common';
import { ModuleFE_DiseaseValue } from '../disease-value/index.js';
export const dispatch_onMultiVarChanged = new ThunderDispatcherV3('__onMultiVarUpdated');
export class ModuleFE_MultiVar_Class extends ModuleFE_BaseApi {
    _v1;
    __getSearchResults = (searchTerm) => {
        const passingDVs = ModuleFE_DiseaseValue.__getSearchResults(searchTerm);
        const passingMVIds = filterDuplicates(passingDVs.map(dv => dv.multiVarId));
        const tempVals = [];
        const filter = new Filter(mv => tempVals);
        filter.setRegexp(false);
        filter.prepareFilter(searchTerm);
        const variableResultsMap = ModuleFE_Variable.cache.all().reduce((map, variable) => {
            const nlpData = ModuleFE_NLPData.cache.unique(variable.nlpDataId);
            if (variable.nlpDataId && !nlpData)
                throw new MUSTNeverHappenException(`Could not find nlp data for id ${variable.nlpDataId}`);
            map[variable._id] = filterInstances([variable.name, nlpData?.synonyms ?? []].flat());
            return map;
        }, {});
        return this.cache.filter(mv => {
            if (passingMVIds.includes(mv._id))
                return true;
            tempVals.length = 0;
            tempVals.push(...mv._variableIds.map(id => variableResultsMap[id]).flat());
            return filter.filterImpl(mv);
        });
    };
    constructor() {
        super(DBDef_MultiVar, dispatch_onMultiVarChanged);
        this._v1 = {
            deleteMultiVarColumn: apiWithBody(ApiDef_MultiVar._v1.deleteMultiVarColumn, this.OnMultiVarColumnDeleted),
            deleteMultiVar: apiWithQuery(ApiDef_MultiVar._v1.deleteMultiVar, this.OnMultiVarDeleted),
            saveMultiVar: apiWithBody(ApiDef_MultiVar._v1.saveMultiVar, this.onMultiVarSaved),
            deleteReference: apiWithBody(ApiDef_MultiVar._v1.deleteReference, this.onReferenceDeleted),
        };
    }
    OnMultiVarDeleted = async (response) => {
        //Update known changes
        await this.onEntryDeleted(response.deletedMultiVar);
        if (response.deletedDiseaseValues?.length)
            await ModuleFE_DiseaseValue.onEntriesDeleted(response.deletedDiseaseValues);
    };
    OnMultiVarColumnDeleted = async (response) => {
        //Update known changes
        await ModuleFE_DiseaseValue.onEntriesDeleted(response.diseaseValues);
        await this.onEntriesUpdated([response.multiVar]);
    };
    onMultiVarSaved = async (response) => {
        await ModuleFE_DiseaseValue.onEntriesDeleted(response.deletedDiseaseValues);
        await this.onEntriesUpdated([response.multiVar]);
    };
    onReferenceDeleted = async (response) => {
        if (response.deletedReference)
            await ModuleFE_Reference.onEntriesDeleted([response.deletedReference]);
        await this.onEntriesUpdated([response.multiVar]);
    };
}
export const ModuleFE_MultiVar = new ModuleFE_MultiVar_Class();
//# sourceMappingURL=ModuleFE_MultiVar.js.map